<div data-test="8xCiIJDU" *mdAutorun>
  <div data-test="40FUErbi" *ngIf="exactClientSyncService.loadingFailed" class="text-red">
    Exact synchronization failed
  </div>
  <div
    *ngIf="exactClientSyncService.showSpinner"
    data-test="kOfLkHu7"
    style="display: flex; align-items: center"
  >
    <i data-test="1HfOo2lc" class="loader-spin loader-spin-inherit-border-color"></i>
    <span
      data-test="nhoYalSE"
      class="text-small"
      style="margin-left: 10px; margin-right: 20px"
    >
      Synchronizing with Exact
    </span>
  </div>
</div>
